import type { FunctionComponent } from "react";
import { Icon, Text } from "@kanda-libs/ks-design-library";
import useCustomQuoteProps from "components/job/LineItem/CustomQuote/useCustomQuoteProps";

export interface CustomQuoteProps {}

const CustomQuote: FunctionComponent<CustomQuoteProps> = function () {
  const { name } = useCustomQuoteProps();

  return (
    <div className="flex flex-col overflow-hidden border bg-neutral-100 border-neutral-200 rounded-xl">
      <div className="p-3 h-38">
        <img
          src="/job-pdf.svg"
          alt="job-pdf"
          className="mx-auto"
          width={200}
          height={200}
        />
      </div>
      <div className="flex flex-row bg-neutral-000 border-t border-neutral-200 px-3 py-3.5">
        <Icon
          icon="file"
          stroke="green-300"
          className="my-auto mr-3"
          size={20}
        />
        <Text text={name} className="my-auto text-14-22 text-neutral-700" />
      </div>
    </div>
  );
};

export default CustomQuote;
